import { useIsMutating, useMutationState } from '@tanstack/react-query';
import { ADMIN_SCAN_SEQUENCE_MUTATION_KEY } from './use-admin-scan-sequence-mutations';

export function useAdminScanSequenceMutationStatus() {
  const isMutating =
    useIsMutating({ mutationKey: ADMIN_SCAN_SEQUENCE_MUTATION_KEY }) > 0;
  const errors = useMutationState({
    filters: { mutationKey: ADMIN_SCAN_SEQUENCE_MUTATION_KEY },
    select: (mutation) => mutation.state.error,
  });

  return { isMutating, error: errors[errors.length - 1] ?? null };
}
